// @ts-ignore
export default function(value) {
  if (!value) return "";
  return value == "pieza"
    ? "Pza"
    : value == "kilos"
    ? "k"
    : value == "litros"
    ? "lt"
    : value;
}
